import type { Attachment } from '@/utils/types'
import InvestorRelationsDocumentViewer from '../../../components/InvestorRelations/InvestorRelationsDocumentViewer'
import assiduousIconUrl from '../../../public/images/AssiduousIcon.svg?url'

interface StaticAttachment {
  attachmentId: string
  fileName: string
  fileType: string
  thumbnailUrl?: string | null
  publicUrl?: string
}

interface StaticDocumentViewerProps {
  attachment: StaticAttachment | null
  isOpen: boolean
  onClose: () => void
  companySlug: string
  section: string
  companyLogoUrl?: string | null
  [key: string]: unknown
}

export default function StaticDocumentViewer({
  attachment,
  isOpen,
  onClose,
  companySlug,
  section,
  companyLogoUrl,
}: StaticDocumentViewerProps) {
  const publicUrl = attachment?.publicUrl || attachment?.thumbnailUrl || null

  return (
    <InvestorRelationsDocumentViewer
      attachment={attachment as Attachment | null}
      isOpen={isOpen}
      onClose={onClose}
      companySlug={companySlug}
      section={section}
      anonymousMode={true}
      preDownloadedBlobUrl={publicUrl}
      companyLogoUrl={companyLogoUrl}
      assiduousIconUrl={assiduousIconUrl}
    />
  )
}
